"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const EmailVerification_1 = require("@/common/components/EmailVerification");
const string_utils_1 = require("@/common/string_utils");
const errors_1 = require("@/common/errors");
function default_1(error) {
    var _a, _b;
    const pwdErrMsgObj = (0, string_utils_1.passwordErrorMessages)();
    const errorCode = (_b = (_a = error.response.data) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.alert_type;
    const replaceToLogin = () => window.location.replace('/login');
    switch (errorCode) {
        case 40000: // ! [unexpected] 이메일 패턴 에러
            alert(EmailVerification_1.emailVeriErrMsgObj.pattern());
            break;
        case 40001: // ? 인증번호 세션 만료
            alert(EmailVerification_1.emailVeriErrMsgObj.expired());
            break;
        case 40002: // ! [unexpected] 인풋 이메일, 소셜 이메일 둘 정보가 모두 없는 경우
            alert('이메일 정보가 없습니다!');
            replaceToLogin();
            break;
        case 40003: // ! [unexpected] 인증받은 이메일과 다른 이메일
            alert('인증한 이메일이 아닙니다!');
            replaceToLogin();
            break;
        case 40004: // ? 이미 가입된 이메일
            window.location.replace('/login/?error=duplicated');
            break;
        case 40005: // ! [unexpected] 비밀번호 형식 에러
        case 40006:
            alert(`비밀번호는 ${pwdErrMsgObj.requiredPattern}`);
            break;
        case 40007: // ! [unexpected] new_pwd !== pwd_confirm
            alert(pwdErrMsgObj.diffConfirm);
            break;
        case 40400: // ! [unexpected] 소셜 회원가입 세션이 없는 경우 (eg. 주소 직접 쳐서 들어온 경우)
            replaceToLogin();
            break;
        default:
            alert((0, errors_1.commonErrorMsg)());
    }
}
exports.default = default_1;
